import React from "react";
import styles from "./Notify.module.scss";
import InfoIcon from '../../assets/icons/24/info.svg'
import SuccessIcon from '../../assets/icons/24/check.svg'
import WarningIcon from '../../assets/icons/24/warning.svg'
import ErrorIcon from '../../assets/icons/24/danger.svg'
import EventsIcon from '../../assets/icons/24/rocket.svg'
import {NotifyPropsInterface} from "./Notify.props.interface";

const Notify: React.FC<NotifyPropsInterface> = (
    {
        type = 'success',
        children = undefined,
        icon = false,
        svg = undefined,
        ...rest
    }) => {

    const handleRenderIcon = () => {
        if (type == 'secondary') return <InfoIcon/>
        if (type == 'success') return <SuccessIcon/>
        if (type == 'events') return <EventsIcon/>
        if (type == 'warning') return <WarningIcon/>

        return <ErrorIcon/>
    }

    return <div className={[styles.container, type ? styles[type] : styles.danger].filter(x => x ?? x).join(' ')} {...rest}>
        {icon ? <>
            {svg ? <div className={styles.icon}>
                {svg}
            </div> : <div className={styles.icon}>
                {handleRenderIcon()}
            </div>}
        </> : null}
        <div className={styles.content}>
            {children}
        </div>
    </div>
};

export default Notify;
